import { Box, Checkbox, FormControlLabel, FormGroup, FormLabel, Stack } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import * as state from '@/components/AssetLabelling/state';
import { notEmpty } from '@/utils';
import { useCallback } from 'react';

export const PointLabels = () => {
  const structure = useAtomValue(state.structure);
  const [labelClassById, setLabelClassById] = useAtom(state.labelClassById);

  const isVisible = useCallback(
    (labelClassId: string) => {
      if (!labelClassById) return true;
      return labelClassById[labelClassId].isVisible ?? true;
    },
    [labelClassById]
  );

  const toggleIsVisible = useCallback(
    (labelClassId: string) => {
      setLabelClassById((current) => {
        if (!current) return undefined;
        const entry = current[labelClassId];
        const updatedEntry = { ...entry, isVisible: !entry.isVisible };
        return { ...current, [labelClassId]: updatedEntry };
      });
    },
    [setLabelClassById]
  );

  return (
    <Stack direction="column">
      <FormGroup>
        <FormLabel sx={{ padding: '15px 0px 5px' }}>Point Labels</FormLabel>
        {structure?.labelClasses?.filter(notEmpty).map(({ id, name, color }) => (
          <Stack direction="row" alignItems="center" key={id}>
            <Box
              style={{
                backgroundColor: color,
                width: '20px',
                height: '20px',
                border: '1px solid #555',
                borderRadius: '10px',
                margin: '5px 10px',
              }}
            />

            <FormControlLabel
              control={<Checkbox checked={isVisible(id)} onChange={() => toggleIsVisible(id)} />}
              label={name}
            />
          </Stack>
        ))}
      </FormGroup>
    </Stack>
  );
};
